import React, { useRef } from 'react';
import clsx from 'clsx';
import TravelersRoomButton from '../TravelersRoomButton/TravelersRoomButton';
import RoomsTooltip from '../Tooltip/RoomsTooltip';
import styles from './RoomSelector.scss';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';
import RoomsTooltipVariant from '../Tooltip/RoomsTooltipVariant';

const RoomsSelector = () => {
  const tooltipTriggerRef = useRef(null);
  const tooltipPopoverRef = useRef(null);
  const isVariant = useIsHomePageVariantHook();
  return (
    <div className={clsx('position-relative width-full flex height-auto',
      isVariant ? 'flex-justify-end' : `flex-justify-start ${styles.roomsSelectorWrapper}`)}
    >
      <TravelersRoomButton ref={tooltipTriggerRef} />
      {isVariant
        ? (
          <RoomsTooltipVariant
            tooltipTriggerRef={tooltipTriggerRef}
            tooltipPopoverRef={tooltipPopoverRef}
          />
        ) : (
          <RoomsTooltip
            tooltipTriggerRef={tooltipTriggerRef}
            tooltipPopoverRef={tooltipPopoverRef}
          />
        )}
    </div>
  );
};

export default RoomsSelector;
